import util from "util";
import imageSize from "image-size";
import fs from "fs";
import imagemagick from "imagemagick";

const IMAGE_SIZE_LIMIT = parseInt(process.env.UPLOAD_IMAGE_SIZE_LIMIT) || 3840;

export default async function reduceImage(filePath) {
  try {
    const imageStat = await util.promisify(imageSize)(filePath);
    if (imageStat.width > IMAGE_SIZE_LIMIT || imageStat.height > IMAGE_SIZE_LIMIT) {
      console.log(`File detected as an image and it's size exceeds limit of ${IMAGE_SIZE_LIMIT}px. Reducing`);
      await new Promise((resolve, reject) =>
          imagemagick.resize({
            srcPath: filePath,
            dstPath: `${filePath}_resized`,
            width: IMAGE_SIZE_LIMIT,
            height: IMAGE_SIZE_LIMIT,
            resizeStyle: 'aspectfit',
          }, function (err, stdout, stderr) {
            if (err) {
              reject(error);
            }
            resolve({filePath});
          })
      );
      fs.unlinkSync(filePath);
      fs.renameSync(`${filePath}_resized`, filePath);
    }
  } catch (e) {
    if (e instanceof TypeError) {
      // not an image
    } else {
      throw e;
    }
  }
}